// File generated from our OpenAPI spec
export const ApiVersion = '2022-11-15';
